var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "showcase-modal fadeIn" }, [
    _c("div", { staticClass: "showcase__header" }, [
      _c("a", {
        staticClass: "slideshow__actions close fa fa-times",
        on: {
          click: function($event) {
            _vm.close()
          }
        }
      })
    ]),
    _c(
      "div",
      { staticClass: "showcase__body" },
      [
        _c("single-flixel", {
          staticClass: "fadeInDown",
          attrs: { flixel: _vm.flixel, resize: "true" }
        }),
        _c("a", {
          staticClass: "link_overlay",
          attrs: { href: /cinemagraph/ + _vm.flixel.hash }
        }),
        _c(
          "a",
          {
            staticClass: "slideshow__actions prev",
            on: {
              click: function($event) {
                _vm.prev(_vm.slideshowIndex)
              }
            }
          },
          [
            _c("img", {
              attrs: {
                srcset:
                  "https://s3.amazonaws.com/flixels/static/static-web/gallery/arrow-left%402x.png" +
                  " 2x, " +
                  "https://s3.amazonaws.com/flixels/static/static-web/gallery/arrow-left.png" +
                  " 1x"
              }
            })
          ]
        ),
        _c(
          "a",
          {
            staticClass: "slideshow__actions next",
            on: {
              click: function($event) {
                _vm.next(_vm.slideshowIndex)
              }
            }
          },
          [
            _c("img", {
              attrs: {
                srcset:
                  "https://s3.amazonaws.com/flixels/static/static-web/gallery/arrow-right%402x.png" +
                  " 2x, " +
                  "https://s3.amazonaws.com/flixels/static/static-web/gallery/arrow-right.png" +
                  " 1x"
              }
            })
          ]
        )
      ],
      1
    ),
    _c("div", { staticClass: "showcase__footer" }, [
      _c("div", { staticClass: "showcase__footer--item" }, [
        _vm.flixel.user_avatar
          ? _c("a", {
              staticClass: "avatar",
              style: { backgroundImage: "url(" + _vm.flixel.user_avatar + ")" },
              attrs: { href: _vm.flixel.username }
            })
          : _vm._e(),
        _c("div", { staticClass: "details" }, [
          _c("div", { staticClass: "h-vertical-align" }, [
            _c(
              "p",
              { staticClass: "h-bold" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "Profile",
                        params: { username: _vm.flixel.username }
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.flixel.username))]
                )
              ],
              1
            ),
            _vm.flixel.caption
              ? _c("p", [
                  _c(
                    "a",
                    { attrs: { href: /cinemagraph/ + _vm.flixel.hash } },
                    [
                      _vm._v(
                        _vm._s(_vm._f("cut")(_vm.flixel.caption, true, 50))
                      )
                    ]
                  )
                ])
              : _vm._e()
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "showcase__footer--item" },
        [_c("social-sharing", { attrs: { flixel: _vm.flixel } })],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2154092e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2154092e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slideshow.vue
// module id = null
// module chunks = 